module.exports = __webpack_public_path__ + "static_pc/img/11.50af7a93.jpg";